module.exports = __webpack_public_path__ + "static/media/sky.ab8b70e6.jpg";